function validateListValues(values, key, rules) {
  const list = values[key];
  const results = {};
  list.forEach((item, itemIndex) => {
    if (typeof item === "object" && item !== null) {
      Object.keys(item).forEach((listItemKey) => {
        if (typeof rules[key][listItemKey] === "function") {
          const error = rules[key][listItemKey](item[listItemKey], values);
          if (error) {
            results[`${key}.${itemIndex}.${listItemKey}`] = error;
          }
        }
      });
    }
  });
  return results;
}

export { validateListValues };
//# sourceMappingURL=validate-list-values.js.map
